import { Receipt, Building2, LineChart } from "lucide-react";

export const CONTACT = {
  email: "Support@baggs2richesllc.com",
  emailHref: "mailto:Support@baggs2richesllc.com",
  phone: "1-855-440-2227",
  phoneHref: "tel:+18554402227",
  hours: "Monday – Saturday, 10:00 AM – 6:00 PM",
  location: "Metro Detroit Area · Serving clients in all 50 states",
};

export const INSTAGRAM = { handle: "@baggs2riches.llc", url: "https://www.instagram.com/baggs2riches.llc/" };

export const SERVICES = [
  {
    key: "tax",
    title: "Tax Preparation",
    icon: Receipt,
    tagline: "Strategic filing that keeps more of what you earn.",
    summary:
      "Accurate, strategy-first tax preparation for individuals, families, self-employed professionals and small businesses — certified to file in all 50 states.",
    items: ["Individual & family returns", "Self-employed & 1099 filers", "Small business returns", "Year-round tax planning", "Filing in all 50 states"],
  },
  {
    key: "business",
    title: "Business Development",
    icon: Building2,
    tagline: "Build the foundation before you build the empire.",
    summary:
      "Guidance for entrepreneurs ready to launch, structure and grow a business with clarity and confidence.",
    items: ["Business formation guidance", "EIN & compliance setup", "Business credit foundations", "Growth strategy sessions"],
  },
  {
    key: "financial",
    title: "Financial Services",
    icon: LineChart,
    tagline: "Turn your money into a plan — and your plan into results.",
    summary:
      "Personalized financial education and planning designed to move you from where you are to where you want to be.",
    items: ["Budgeting & cash-flow coaching", "Credit education", "Savings & wealth-building plans", "Financial goal mapping"],
  },
];

export const SERVICE_OPTIONS = ["Tax Preparation", "Business Development", "Financial Services", "Financial Education / Academy", "Not sure yet"];

export const POSITIONS = ["Tax Preparer", "Client Success Associate", "Business Development Associate", "Academy Instructor", "Other / General Interest"];

export const FAQS = [
  { q: "How do I get started with B2R?", a: "Complete our Client Intake Form or book a consultation. A member of our team will reach out to discuss your goals and next steps." },
  { q: "Do you offer virtual appointments?", a: "Yes. When booking, choose a virtual or in-person consultation — whichever works best for you." },
  { q: "What should I bring to my tax appointment?", a: "Typically a photo ID, income statements (W-2s, 1099s), and any relevant deduction records. We'll send a personalized checklist after your consultation." },
  { q: "How do I send sensitive documents?", a: "Please do not email sensitive documents. A secure document portal is coming soon; until then our team will guide you through a safe submission method." },
  { q: "What is the B2R Financial Freedom Academy?", a: "Our education hub offering classes and workshops on financial literacy, credit, and business building. Browse upcoming sessions and register online." },
  { q: "Can I join the B2R team?", a: "We're always looking for good people. Submit an application on our Careers page and we'll be in touch." },
];

export const NAV = [
  { to: "/academy", label: "Classes" },
  { to: "/careers", label: "Careers" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/contact", label: "Contact" },
];
